import { scrollToId } from "@/lib/scroll";
import { CONTATTI } from "@/data/content";
import { useLang } from "@/i18n";

export default function Footer() {
    const { ui } = useLang();

    const NAV = [
        { label: ui.nav.produzioni, href: "#produzioni" },
        { label: ui.nav.chiSiamo, href: "#chi-siamo" },
        { label: ui.nav.team, href: "#team" },
        { label: ui.nav.stampa, href: "#stampa" },
        { label: ui.nav.contatti, href: "#contatti" },
    ];

    return (
        <footer data-testid="footer" className="border-t border-white/5 bg-[#060608] px-5 pb-10 pt-16 sm:px-8">
            <div className="mx-auto grid max-w-7xl gap-12 md:grid-cols-3">
                <div>
                    <div className="flex items-center gap-3">
                        <img src="/logo.png" alt="Logo RED PRIVATE SRL" className="h-10 w-auto" />
                        <span className="font-display text-lg font-extrabold tracking-[0.18em] text-white">
                            RED<span className="text-brand">PRIVATE</span>
                        </span>
                    </div>
                    <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">{ui.footer.tagline}</p>
                </div>
                <div>
                    <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">{ui.footer.nav}</p>
                    <ul className="space-y-2.5">
                        {NAV.map((n) => (
                            <li key={n.href}>
                                <button
                                    data-testid={`footer-link-${n.href.replace("#", "")}`}
                                    onClick={() => scrollToId(n.href)}
                                    className="text-sm text-slate-400 transition-colors hover:text-brand"
                                >
                                    {n.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">{ui.footer.contatti}</p>
                    <ul className="space-y-2.5 text-sm text-slate-400">
                        <li>{CONTATTI.sedi}</li>
                        <li>
                            <a href={`mailto:${CONTATTI.email}`} className="transition-colors hover:text-brand">
                                {CONTATTI.email}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="mx-auto mt-14 flex max-w-7xl flex-col items-center justify-between gap-4 border-t border-white/5 pt-8 sm:flex-row">
                <p className="text-xs text-slate-600">{ui.footer.rights}</p>
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-600">{ui.footer.city}</p>
            </div>
        </footer>
    );
}
